<div container>
  <ui-error [state]="loadState"></ui-error>

  <form [formGroup]="form" *visible="loadState.isCompleted" (submit)="submit()">
    <div container>
      <ui-alert type="info">
        <div ui-body i18n>מספיק למלא פרטי קרוב אחד</div>
      </ui-alert>
    </div>

    <div class="table-responsive mat-elevation-z2" *ngIf="!appLayout.isMobile">
      <table
        mat-table
        #dataTable
        [dataSource]="dataSource"
        formArrayName="relatives"
        [ui-column-width]="[140, 120, 120, 120, 100, 120, 170, 120, 120, 72]"
      >
        <ng-container matColumnDef="relation-type">
          <th mat-header-cell *matHeaderCellDef i18n>קרבה משפחתית</th>

          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field *ngIf="row.value">
              <mat-select formControlName="relationType">
                <mat-option value i18n>
                  {gender, select, male {בחר} female {בחרי}}
                </mat-option>
                <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Spouse, row) || row.value.relationType === RelationTypes.Spouse" [value]="RelationTypes.Spouse" i18n>
                  {gender, select, male {בת זוג} female {בן זוג}}
                </mat-option>
                <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Father, row) || row.value.relationType === RelationTypes.Father" [value]="RelationTypes.Father" i18n>אב</mat-option>
                <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Mother, row) || row.value.relationType === RelationTypes.Mother" [value]="RelationTypes.Mother" i18n>אם</mat-option>
                <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Brother, row) || row.value.relationType === RelationTypes.Brother" [value]="RelationTypes.Brother" i18n>אח</mat-option>
                <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Sister, row) || row.value.relationType === RelationTypes.Sister" [value]="RelationTypes.Sister" i18n>אחות</mat-option>
                <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Son, row) || row.value.relationType === RelationTypes.Son" [value]="RelationTypes.Son" i18n>ילד</mat-option>
                <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Daughter, row) || row.value.relationType === RelationTypes.Daughter" [value]="RelationTypes.Daughter" i18n>ילדה</mat-option>
                <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Boyfriend, row) || row.value.relationType === RelationTypes.Boyfriend" [value]="RelationTypes.Boyfriend" i18n>חבר</mat-option>
                <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Girlfriend, row) || row.value.relationType === RelationTypes.Girlfriend" [value]="RelationTypes.Girlfriend" i18n>חברה</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="first-name">
          <th mat-header-cell *matHeaderCellDef i18n>שם פרטי</th>

          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field floatLabel="never">
              <input
                type="text"
                matInput
                formControlName="firstName"
                autocomplete="off"
                i18n-placeholder
                placeholder="שם פרטי"
                pattern="^([a-zA-Zא-ת ]*)$"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="last-name">
          <th mat-header-cell *matHeaderCellDef i18n>שם משפחה</th>

          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field floatLabel="never">
              <input
                type="text"
                matInput
                formControlName="lastName"
                autocomplete="off"
                i18n-placeholder
                placeholder="שם משפחה"
                pattern="^([a-zA-Zא-ת ]*)$"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="birth-country">
          <th mat-header-cell *matHeaderCellDef i18n>ארץ לידה</th>

          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <country-field
              formControlName="birthCountry"
              [label]="birthCountryPlaceholder.text"
              floatLabel="never"
              appearance="legacy"
            >
            </country-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="education-years">
          <th mat-header-cell *matHeaderCellDef i18n>שנות לימוד</th>

          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field floatLabel="never">
              <input
                matInput
                type="number"
                formControlName="educationYears"
                min="0"
                max="20"
                pattern="^([0-9]{1}|1[0-9]|20)$"
                autocomplete="off"
                i18n-placeholder
                placeholder="שנות לימוד"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="occupation-type">
          <th mat-header-cell *matHeaderCellDef i18n>תעסוקה</th>

          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field floatLabel="never">
              <mat-select formControlName="occupationType">
                <mat-option value i18n>{gender, select, male {בחר} female {בחרי}}</mat-option>
                <mat-option [value]="OccupationTypes.Employee" i18n>{relativeGender(row), select,
                  male {עובד}
                  female {עובדת}
                }</mat-option>
                <mat-option [value]="OccupationTypes.SelfEmployed" i18n>{relativeGender(row), select,
                  male {עצמאי}
                  female {עצמאית}
                }</mat-option>
                <mat-option [value]="OccupationTypes.Studying" i18n>{relativeGender(row), select,
                  male {לומד}
                  female {לומדת}
                }</mat-option>
                <mat-option [value]="OccupationTypes.Passed" i18n>{relativeGender(row), select,
                  male {נפטר}
                  female {נפטרה}
                }</mat-option>
                <mat-option [value]="OccupationTypes.Pension" i18n>{relativeGender(row), select,
                  male {פנסיונר}
                  female {פנסיונרית}
                }</mat-option>
                <mat-option [value]="OccupationTypes.PartiallyEmployed" i18n>{relativeGender(row), select,
                  male {עובד חלקית}
                  female {עובדת חלקית}
                }</mat-option>
                <mat-option [value]="OccupationTypes.Unemployed" i18n>{relativeGender(row), select,
                  male {לא עובד}
                  female {לא עובדת}
                }</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="work-place">
          <th mat-header-cell *matHeaderCellDef i18n>מקום לימודים / עבודה</th>

          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field floatLabel="never">
              <input
                matInput
                type="text"
                formControlName="workPlace"
                autocomplete="off"
                i18n-placeholder
                placeholder="מקום לימודים/ עבודה"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="job-description">
          <th mat-header-cell *matHeaderCellDef i18n>תפקיד</th>

          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field floatLabel="never">
              <input
                type="text"
                matInput
                formControlName="jobDescription"
                autocomplete="off"
                i18n-placeholder
                placeholder="תפקיד"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="work-phone">
          <th mat-header-cell *matHeaderCellDef i18n>טלפון</th>

          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field floatLabel="never">
              <input
                type="text"
                matInput
                type="tel"
                formControlName="workPhone"
                autocomplete="off"
                i18n-placeholder
                placeholder="טלפון"
                pattern="^([\d\-\+\s\(\)]{7,})$"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>

          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <button
              mat-icon-button
              type="button"
              [matTooltip]="deleteTooltip.text"
              (click)="removeRow(row)"
              [disabled]="!canRemoveRow(row)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; let i = index; columns: displayColumns"></tr>
      </table>
    </div>

    <div *ngIf="appLayout.isMobile" formArrayName="relatives">
      <ng-template #relativeEditor let-row let-i="index">
        <registration-entry-editor-shell
          [formGroupName]="i"
          [mode]="rowsEditor.isAddingRow(row) ? 'add' : 'edit'"
          [addTitle]="addRelativeTitle.text"
          [editTitle]="editRelativeTitle.text"
          [invalid]="rowsEditor.invalid"
          [invalidBody]="relativeInvalidBody.text"
          [cancelTooltip]="cancelTooltip.text"
          (cancel)="rowsEditor.cancel(row)"
          (save)="rowsEditor.save(row)"
        >
          <mat-form-field appearance="fill">
            <mat-label i18n>קרבה משפחתית</mat-label>
            <mat-select required formControlName="relationType">
              <mat-option value i18n>
                {gender, select, male {בחר} female {בחרי}}
              </mat-option>
              <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Spouse, row) || row.value.relationType === RelationTypes.Spouse" [value]="RelationTypes.Spouse" i18n>
                {gender, select, male {בת זוג} female {בן זוג}}
              </mat-option>
              <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Father, row) || row.value.relationType === RelationTypes.Father" [value]="RelationTypes.Father" i18n>אב</mat-option>
              <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Mother, row) || row.value.relationType === RelationTypes.Mother" [value]="RelationTypes.Mother" i18n>אם</mat-option>
              <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Brother, row) || row.value.relationType === RelationTypes.Brother" [value]="RelationTypes.Brother" i18n>אח</mat-option>
              <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Sister, row) || row.value.relationType === RelationTypes.Sister" [value]="RelationTypes.Sister" i18n>אחות</mat-option>
              <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Son, row) || row.value.relationType === RelationTypes.Son" [value]="RelationTypes.Son" i18n>ילד</mat-option>
              <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Daughter, row) || row.value.relationType === RelationTypes.Daughter" [value]="RelationTypes.Daughter" i18n>ילדה</mat-option>
              <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Boyfriend, row) || row.value.relationType === RelationTypes.Boyfriend" [value]="RelationTypes.Boyfriend" i18n>חבר</mat-option>
              <mat-option *ngIf="isRelationTypeAvailable(RelationTypes.Girlfriend, row) || row.value.relationType === RelationTypes.Girlfriend" [value]="RelationTypes.Girlfriend" i18n>חברה</mat-option>
            </mat-select>
            <mat-error *ngIf="row | hasError: 'relationType'" i18n>שדה חובה</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>שם פרטי</mat-label>
            <input
              type="text"
              matInput
              required
              formControlName="firstName"
              autocomplete="off"
              pattern="^([a-zA-Zא-ת ]*)$"
            />
            <mat-error *ngIf="row | hasError: 'firstName'" i18n>שדה חובה</mat-error>
            <mat-error *ngIf="row | hasError: 'firstName' : 'pattern'" i18n>שם פרטי לא תקין</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>שם משפחה</mat-label>
            <input
              type="text"
              matInput
              required
              formControlName="lastName"
              autocomplete="off"
              pattern="^([a-zA-Zא-ת ]*)$"
            />
            <mat-error *ngIf="row | hasError: 'lastName'" i18n>שדה חובה</mat-error>
            <mat-error *ngIf="row | hasError: 'lastName' : 'pattern'" i18n>שם משפחה לא תקין</mat-error>
          </mat-form-field>

          <country-field formControlName="birthCountry" [label]="birthCountryLabel.text" appearance="fill">
          </country-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>שנות לימוד</mat-label>
            <input
              matInput
              type="number"
              formControlName="educationYears"
              min="0"
              max="20"
              pattern="^([0-9]{1}|1[0-9]|20)$"
              autocomplete="off"
            />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>תעסוקה</mat-label>
            <mat-select formControlName="occupationType">
              <mat-option value i18n>{gender, select, male {בחר} female {בחרי}}</mat-option>
              <mat-option [value]="OccupationTypes.Employee" i18n>{relativeGender(row), select,
                male {עובד}
                female {עובדת}
              }</mat-option>
              <mat-option [value]="OccupationTypes.SelfEmployed" i18n>{relativeGender(row), select,
                male {עצמאי}
                female {עצמאית}
              }</mat-option>
              <mat-option [value]="OccupationTypes.Studying" i18n>{relativeGender(row), select,
                male {לומד}
                female {לומדת}
              }</mat-option>
              <mat-option [value]="OccupationTypes.Passed" i18n>{relativeGender(row), select,
                male {נפטר}
                female {נפטרה}
              }</mat-option>
              <mat-option [value]="OccupationTypes.Pension" i18n>{relativeGender(row), select,
                male {פנסיונר}
                female {פנסיונרית}
              }</mat-option>
              <mat-option [value]="OccupationTypes.PartiallyEmployed" i18n>{relativeGender(row), select,
                male {עובד חלקית}
                female {עובדת חלקית}
              }</mat-option>
              <mat-option [value]="OccupationTypes.Unemployed" i18n>{relativeGender(row), select,
                male {לא עובד}
                female {לא עובדת}
              }</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>מקום לימודים / עבודה</mat-label>
            <input matInput type="text" formControlName="workPlace" autocomplete="off" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>תפקיד</mat-label>
            <input type="text" matInput formControlName="jobDescription" autocomplete="off" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>טלפון</mat-label>
            <input
              type="tel"
              matInput
              required
              formControlName="workPhone"
              autocomplete="off"
              pattern="^([\d\-\+\s\(\)]{7,})$"
            />
            <mat-error *ngIf="row | hasError: 'workPhone'" i18n>שדה חובה</mat-error>
            <mat-error *ngIf="row | hasError: 'workPhone' : 'pattern'" i18n>מספר הטלפון אינו תקין</mat-error>
          </mat-form-field>
        </registration-entry-editor-shell>
      </ng-template>

      <ng-template #relativeCard let-row let-i="index">
        <registration-entry-card
          [title]="rowFullName(row)"
          [meta]="row.value.workPhone"
          metaDir="ltr"
          [editTooltip]="editTooltip.text"
          [deleteTooltip]="deleteTooltip.text"
          [canDelete]="canRemoveRow(row)"
          (edit)="rowsEditor.startEdit(row)"
          (delete)="removeRow(row)"
        >
          <div
            footerStart
            class="registration-entry-card__meta"
            *ngIf="row.value.occupationType"
            [ngSwitch]="row.value.occupationType"
          >
            <ng-container *ngSwitchCase="OccupationTypes.Employee" i18n>
              {relativeGender(row), select, male {עובד} female {עובדת}}
            </ng-container>
            <ng-container *ngSwitchCase="OccupationTypes.SelfEmployed" i18n>
              {relativeGender(row), select, male {עצמאי} female {עצמאית}}
            </ng-container>
            <ng-container *ngSwitchCase="OccupationTypes.Studying" i18n>
              {relativeGender(row), select, male {לומד} female {לומדת}}
            </ng-container>
            <ng-container *ngSwitchCase="OccupationTypes.Passed" i18n>
              {relativeGender(row), select, male {נפטר} female {נפטרה}}
            </ng-container>
            <ng-container *ngSwitchCase="OccupationTypes.Pension" i18n>
              {relativeGender(row), select, male {פנסיונר} female {פנסיונרית}}
            </ng-container>
            <ng-container *ngSwitchCase="OccupationTypes.PartiallyEmployed" i18n>
              {relativeGender(row), select, male {עובד חלקית} female {עובדת חלקית}}
            </ng-container>
            <ng-container *ngSwitchCase="OccupationTypes.Unemployed" i18n>
              {relativeGender(row), select, male {לא עובד} female {לא עובדת}}
            </ng-container>
          </div>
          <span footerBadge class="registration-entry-card__badge" [ngSwitch]="row.value.relationType">
            <ng-container *ngSwitchCase="RelationTypes.Spouse" i18n>
              {gender, select, male {בת זוג} female {בן זוג}}
            </ng-container>
            <ng-container *ngSwitchCase="RelationTypes.Father" i18n>אב</ng-container>
            <ng-container *ngSwitchCase="RelationTypes.Mother" i18n>אם</ng-container>
            <ng-container *ngSwitchCase="RelationTypes.Brother" i18n>אח</ng-container>
            <ng-container *ngSwitchCase="RelationTypes.Sister" i18n>אחות</ng-container>
            <ng-container *ngSwitchCase="RelationTypes.Son" i18n>ילד</ng-container>
            <ng-container *ngSwitchCase="RelationTypes.Daughter" i18n>ילדה</ng-container>
            <ng-container *ngSwitchCase="RelationTypes.Boyfriend" i18n>חבר</ng-container>
            <ng-container *ngSwitchCase="RelationTypes.Girlfriend" i18n>חברה</ng-container>
          </span>
        </registration-entry-card>
      </ng-template>

      <registration-entry-list
        [rows]="rows"
        [editor]="rowsEditor"
        [addLabel]="addRelativeTitle.text"
        [editorTemplate]="relativeEditor"
        [cardTemplate]="relativeCard"
      >
      </registration-entry-list>
    </div>

    <ui-alert type="warning" *visible="showError && (errorList?.length > 0 || _completedRows.length <= 0)">
      <div ui-header i18n>לא ניתן לשמור מכיון שאחד או יותר מהפרטים שגויים או חסרים</div>

      <ul ui-body>
        <ng-container *ngIf="errorList?.length > 0; else generalError">
          <ng-container *ngFor="let error of errorList">
            <li *ngIf="error == 'firstName-required'" i18n>שם פרטי חובה</li>
            <li *ngIf="error == 'firstName-pattern'" i18n>שם פרטי לא תקין</li>
            <li *ngIf="error == 'lastName-required'" i18n>שם משפחה חובה</li>
            <li *ngIf="error == 'lastName-pattern'" i18n>שם משפחה לא תקין</li>
            <li *ngIf="error == 'workPhone-required'" i18n>טלפון חובה</li>
            <li *ngIf="error == 'workPhone-pattern'" i18n>מספר הטלפון אינו תקין</li>
          </ng-container>
        </ng-container>

        <ng-template #generalError>
          <li i18n>חובה להזין לפחות קרוב משפחה אחד</li>
        </ng-template>
      </ul>
    </ui-alert>

    <ui-error [state]="saveState"></ui-error>

    <ui-progress-button color="primary" [state]="saveState" i18n>
      {saveState.value, select, inProcess {שומר נתונים} other {שמור והמשך}}
    </ui-progress-button>
  </form>
</div>

<term #birthCountryPlaceholder i18n>
  {gender, select, male {בחר} female {בחרי}}
  ארץ לידה
</term>

<term #birthCountryLabel i18n>ארץ לידה</term>

<term #deleteTooltip i18n>
  {gender, select, male {מחק} female {מחקי}}
  שורה
</term>

<term #editTooltip i18n>
  {gender, select, male {ערוך} female {ערכי}}
</term>

<term #cancelTooltip i18n>ביטול</term>

<term #addRelativeTitle i18n>הוספת קרוב משפחה</term>

<term #editRelativeTitle i18n>עריכת קרוב משפחה</term>

<term #relativeInvalidBody i18n>חובה לבחור קרבה משפחתית ולהזין שם פרטי, שם משפחה וטלפון</term>
